import { render, staticRenderFns } from "./IconOtherAsset.vue?vue&type=template&id=a7a27b74&scoped=true&"
import script from "./IconOtherAsset.vue?vue&type=script&lang=js&"
export * from "./IconOtherAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a27b74",
  null
  
)

export default component.exports